module.exports = __webpack_public_path__ + "img/98.3c082fc9.jpg";